"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.setErrorsCreator = setErrorsCreator;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/object/keys"));
var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/for-each"));
var _actions = require("../../actions");
var _utils = require("../../utils");
function setErrorsCreator(getState, dispatch) {
  return function (errorOverridesByName = {}) {
    const {
      inputStates
    } = getState();
    const inputNames = errorOverridesByName ? (0, _keys.default)(errorOverridesByName) : [];
    (0, _forEach.default)(inputNames).call(inputNames, inputName => {
      const registeredInput = (0, _utils.getFirstRegisteredInputByName)(inputStates, inputName);
      dispatch((0, _actions.updateInputStateValueIfChanged)(registeredInput, 'errorStateOverride', errorOverridesByName[inputName]));
    });
  };
}